module.exports = __webpack_public_path__ + "media/images/icons/icon-quote-large-b6521f4ff90f8abb4e4464c04e238a9f.svg";